import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Manifesto from "@/components/site/Manifesto";
import Products from "@/components/site/Products";
import Machine from "@/components/site/Machine";
import HowItWorks from "@/components/site/HowItWorks";
import Marquee from "@/components/site/Marquee";
import Founders from "@/components/site/Founders";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative bg-[#D9F4CD] text-[#17320B]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Manifesto />
        <Products />
        <Machine />
        <HowItWorks />
        <Marquee />
        <Founders />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
